<div class="form">
  <div class="form__title">{{'t.want-cancel-bonus' | translate}}</div>
  <div class="form__description">{{'t.pleace-note-winning' | translate}}</div>

  <div class="submit-container">
    <button class="btn btn--filled-primary" (click)="modal.close(true)">{{'btn.accept' | translate}}</button>
    <button class="btn btn--simple-primary" (click)="modal.close()">{{'btn.cancel' | translate}}</button>
  </div>
</div>
